// ============================================================
// ЗАДАЧА 2: Фильтрация, аномалии, чанки, стилистика
// ============================================================

// ---------- Фильтр: только мои сообщения ----------

export function filterMyMessages(messages, myName) {
  const normalized = myName.trim().toLowerCase()
  const filtered = []

  for (const msg of messages) {
    if (!msg.from || msg.from.trim().toLowerCase() !== normalized) continue

    filtered.push({
      myText: msg.text,
      contextText: msg.reply_to_text || null,
      date: msg.date,
      chatName: msg.chatName || '',
      chatType: msg.chatType || 'personal',
    })
  }

  console.log(
    `[FILTER] filterMyMessages: ${filtered.length}/${messages.length} my messages`
  )
  return filtered
}


// ---------- Контекстуальные чанки ----------

export function buildContextualChunks(filteredMessages, chunkSize = 40) {
  const chunks = []
  let id = 0

  for (let i = 0; i < filteredMessages.length; i += chunkSize) {
    const slice = filteredMessages.slice(i, i + chunkSize)

    const chunkText = slice
      .map((m) => {
        const context = m.contextText
          ? `=== Контекст: ${m.contextText.slice(0, 200)} ===\n`
          : ''
        return `${context}Мой ответ: ${m.myText}`
      })
      .join('\n\n')

    const dates = slice.map((m) => m.date).filter(Boolean)
    const dateRange = dates.length > 0 ? `${dates[0]} — ${dates[dates.length - 1]}` : 'дата неизвестна'
    const sources = [...new Set(slice.map((m) => m.chatName || m.chatType))]
    const chatTypes = [...new Set(slice.map((m) => m.chatType).filter(Boolean))]
    const dominantChatType = chatTypes.includes('group') && chatTypes.includes('personal')
      ? 'mixed' : chatTypes[0] || 'unknown'

    chunks.push({
      id: id++,
      text: chunkText,
      source: sources.join(', '),
      chatType: dominantChatType,
      dateRange,
    })
  }

  console.log(
    `[FILTER] buildContextualChunks: ${chunks.length} chunks from ${filteredMessages.length} messages`
  )
  return chunks
}

// ---------- Анализ стилистики ----------

export function analyzeStyle(messages) {
  if (messages.length === 0) {
    return {
      avg_message_length: 0,
      vocabulary: [],
      emoji_usage: 0,
      formality_score: 0,
      sentence_patterns: [],
    }
  }

  const texts = messages.map((m) => m.myText || m.text || '')

  // Средняя длина сообщения
  const avg_message_length =
    Math.round(texts.reduce((s, t) => s + t.length, 0) / texts.length)

  // Словарь — топ-50 слов (>3 букв)
  const wordFreq = {}
  for (const text of texts) {
    const words = text.toLowerCase().match(/[а-яёa-z]{4,}/g) || []
    for (const w of words) {
      wordFreq[w] = (wordFreq[w] || 0) + 1
    }
  }
  const vocabulary = Object.entries(wordFreq)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 50)
    .map(([word, count]) => ({ word, count }))

  // Использование эмодзи (в % от сообщений)
  const emojiRegex =
    /[\u{1F300}-\u{1FFFF}\u{2600}-\u{27FF}\u{2B00}-\u{2BFF}]/u
  const withEmoji = texts.filter((t) => emojiRegex.test(t)).length
  const emoji_usage = Math.round((withEmoji / texts.length) * 100)

  // Формальность: отсутствие мата, полные предложения, заглавные буквы в начале
  const RU_MAT_LOCAL = /\b(блять|бля|ёб|еб|пизд|хуй|хуе|хуя|мудак|сука|ёп|бл+я|нахуй|нахой)\b/i
  const matCount = texts.filter((t) => RU_MAT_LOCAL.test(t)).length
  const capsStart = texts.filter((t) => /^[А-ЯЁA-Z]/.test(t)).length
  const longSentences = texts.filter((t) => t.length > 80).length
  const formality_score = Math.round(
    ((texts.length - matCount) / texts.length) * 50 +
      (capsStart / texts.length) * 30 +
      (longSentences / texts.length) * 20
  )

  // Паттерны предложений
  const shortMsgs = texts.filter((t) => t.length < 20).length
  const mediumMsgs = texts.filter((t) => t.length >= 20 && t.length < 100).length
  const longMsgs = texts.filter((t) => t.length >= 100).length
  const questionMsgs = texts.filter((t) => t.includes('?')).length

  const sentence_patterns = [
    `Короткие (<20 символов): ${Math.round((shortMsgs / texts.length) * 100)}%`,
    `Средние (20-100): ${Math.round((mediumMsgs / texts.length) * 100)}%`,
    `Длинные (>100): ${Math.round((longMsgs / texts.length) * 100)}%`,
    `С вопросом: ${Math.round((questionMsgs / texts.length) * 100)}%`,
  ]

  const result = {
    avg_message_length,
    vocabulary,
    emoji_usage,
    formality_score,
    sentence_patterns,
    total_messages: texts.length,
  }

  console.log(
    `[STYLE] analyzeStyle: avg_len:${avg_message_length} emoji:${emoji_usage}% formality:${formality_score}`
  )
  return result
}
